
import { useNavigate } from "react-router-dom";


import './claveError.scss';
import { useEffect } from "react";

function ClaveError() {
  const navigate = useNavigate();
  useEffect(()=>{
    navigate('/login', { state: { errorMessage: 'Usuario no Autorizado' } });
  },[navigate])
  
}
export default ClaveError